import { render } from "./bookingDialogue.vue?vue&type=template&id=e161c70c"
import script from "./bookingDialogue.vue?vue&type=script&lang=js"
export * from "./bookingDialogue.vue?vue&type=script&lang=js"

import "./bookingDialogue.vue?vue&type=style&index=0&id=e161c70c&lang=scss"
script.render = render

export default script